import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  formControlError: {
    '&.Mui-error': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      padding: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
      border: `${theme.palette.primary.main} !important`,
    }
  },
  formLabelError: {
    '&.Mui-error': {
      color: `${theme.palette.primary.main} !important`,
    }
  },
  checkboxError: {
    '&.Mui-error': {
      color: `${theme.palette.primary.main} !important`,
      '&.Mui-checked': {
        color: `${theme.palette.primary.main} !important`,
      }
    }
  },
  helperTextError: {
    '&.Mui-error': {
      color: `${theme.palette.primary.main} !important`
    }
  },
  formGroup: {
    flexDirection: (props: any) => props.layout === 'horizontal' ? 'row' : 'column'
  }
}));

export default useStyles;
